import config from '../config';
import { login, logout, successLogin, errorLogin } from '../actions/auth';
import { loadUserById, loadUserByIdForProfile, unsetCurrentUser } from '../actions/users';
import { setConfig } from '../actions/config';
import fetch from 'cross-fetch';
import store from 'store2';
import { push } from 'react-router-redux';
import { fetchUserByIdForProfile } from './users';
import { addNotification as notify } from 'reapop';

export function loginUserById(id, isItForProfile) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/users/loginAs/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (isItForProfile) {
              dispatch(loadUserByIdForProfile({ userProfile: json }));
            }
            else {
              dispatch(loadUserById({ currentUser: json }));
            }
            if (json.password && json.email) {
              loginUser({
                username: json.email,
                password: json.password,
              })(dispatch);
            } else {
              dispatch(notify({
                title: 'Login',
                message: 'Login failed as this user failed',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000,
              }));
            }
          }

          return json;
        })
    }
  }
};

export function loginUser(data) {
  return dispatch => {
    return fetch(`${config.apiEndpoint}/authenticate`, {
      method: 'POST',
      body: JSON.stringify({
        email: data.username,
        password: data.password,
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json && json.status === 'success') {
          // Set user data
          store.set('user', json);

          // Set login data
          dispatch(successLogin(json));

          // Get user data
          fetchUserByIdForProfile(json.userId)(dispatch);

          dispatch(push('/'));

          dispatch(notify({
            title: 'Login',
            message: 'You are successfully logged in',
            status: 'success',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000,
          }));
        } else {
          if (json && json.status == 'fail') {
            dispatch(notify({
              title: 'Login',
              message: 'Incorrect user name or password',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000,
            }));
          } else {
            dispatch(notify({
              title: 'Login',
              message: 'Login error',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000,
            }));
          }
        }
      })
      .catch(response => {
        dispatch(notify({
          title: 'Login',
          message: 'Login failed',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000,
        }));
      })
      .catch(error => {
        window.alert(`Login error ${error.message}`);
      });
  }
}

export function logoutUser() {
  return dispatch => {
    store.set('user', {});
    dispatch(logout());
    dispatch(unsetCurrentUser());
    dispatch(setConfig('rightSidebar', false));
    dispatch(push('/pages/login'));
  };
}



// WEBPACK FOOTER //
// ./src/api/auth.js